import { render, staticRenderFns } from "./DetailLock.vue?vue&type=template&id=1fcd8791&scoped=true"
import script from "./DetailLock.vue?vue&type=script&lang=js"
export * from "./DetailLock.vue?vue&type=script&lang=js"
import style0 from "./DetailLock.vue?vue&type=style&index=0&id=1fcd8791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcd8791",
  null
  
)

export default component.exports